// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/widgets/TagList/styles.scss
// module id = 824
// module chunks = 0